import i18next from "@/i18n";

import { ReturnReason } from "@repo/shopify/types/enum";

export const COLLECTION_SORT = [
  { label: "Recent", value: "COLLECTION_DEFAULT", reverse: false, name: "recent", sortIndex: 0 },
  { label: "Best Selling", value: "BEST_SELLING", reverse: false, name: "best_selling", sortIndex: 1 },
  { label: "Price: High to Low", value: "PRICE", reverse: true, name: "price_descending", sortIndex: 2 },
  { label: "Price: Low to High", value: "PRICE", reverse: false, name: "price_ascending", sortIndex: 3 },
];

export const SEARCH_SORT = [
  { label: "Best Match", value: "RELEVANCE", reverse: false, name: "relevance", sortIndex: 0 },
  { label: "Price: High to Low", value: "PRICE", reverse: true, name: "price_descending", sortIndex: 1 },
  { label: "Price: Low to High", value: "PRICE", reverse: false, name: "price_ascending", sortIndex: 2 },
];

export const VIEW_OPTIONS = [
  { name: "seperate", id: "seperate", value: "seperate", label: "Seperate" },
  { name: "combined", id: "combined", value: "combined", label: "Combined" },
];

export interface ISortOption {
  label: string;
  value: string;
  reverse: boolean;
}

export const SORT: ISortOption[] = [
  { label: "Sort by Oldest", value: "CREATED", reverse: false },
  { label: "Sort by Newest", value: "CREATED", reverse: true },
];

export const INTL_ASIA_PROVIDER = [
  "ALIPAY",
  "ALIPAYHK",
  "BILLEASE",
  "BOOST",
  "BPI",
  "DANA",
  "GCASH",
  "RABBIT_LINE_PAY",
  "TOUCHNGO",
  "TRUEMONEY",
];

export const translationReturnReason: Partial<Record<ReturnReason, string>> = {
  [ReturnReason.DEFAULT]: i18next.t("return_reason.default"),
  [ReturnReason.UNWANTED]: i18next.t("return_reason.unwanted"),
  [ReturnReason.DEFECTIVE]: i18next.t("return_reason.defective"),
  [ReturnReason.WRONG_ITEM]: i18next.t("return_reason.wrong_item"),
  [ReturnReason.SIZE_TOO_LARGE]: i18next.t("return_reason.size_large"),
  [ReturnReason.SIZE_TOO_SMALL]: i18next.t("return_reason.size_small"),
};

export const RETURN_REASON_OPTIONS: { name: string; value: ReturnReason }[] = [
  { name: "Select Reason", value: ReturnReason.DEFAULT },
  { name: i18next.t("return_reason.unwanted"), value: ReturnReason.UNWANTED },
  { name: i18next.t("return_reason.defective"), value: ReturnReason.DEFECTIVE },
  { name: i18next.t("return_reason.wrong_item"), value: ReturnReason.WRONG_ITEM },
  { name: i18next.t("return_reason.size_large"), value: ReturnReason.SIZE_TOO_LARGE },
  { name: i18next.t("return_reason.size_small"), value: ReturnReason.SIZE_TOO_SMALL },
];

export const MEMBERSHIP_TABLE = [
  {
    membership: "Member",
    benefits: i18next.t("account.membership.member.benefits"),
    discount_code: i18next.t("account.membership.member.discount_code"),
    purchase_amount: i18next.t("account.membership.member.purchase_amount"),
  },
  {
    membership: "Silver",
    benefits: i18next.t("account.membership.silver.benefits"),
    discount_code: i18next.t("account.membership.silver.discount_code"),
    purchase_amount: i18next.t("account.membership.silver.purchase_amount"),
  },
  {
    membership: "Gold",
    benefits: i18next.t("account.membership.gold.benefits"),
    discount_code: i18next.t("account.membership.gold.discount_code"),
    purchase_amount: i18next.t("account.membership.gold.purchase_amount"),
  },
  {
    membership: "Platinum",
    benefits: i18next.t("account.membership.platinum.benefits"),
    discount_code: i18next.t("account.membership.platinum.discount_code"),
    purchase_amount: i18next.t("account.membership.platinum.purchase_amount"),
  },
  {
    membership: "VIP",
    benefits: i18next.t("account.membership.vip.benefits"),
    discount_code: i18next.t("account.membership.vip.discount_code"),
    purchase_amount: i18next.t("account.membership.vip.purchase_amount"),
  },
];
